import { operatorApiFetch } from './apiService';

export const permissionTemplateService = {
  fetchList: async () => {
    const response = await operatorApiFetch('permission_templates', {
      method: 'GET',
    });
    return response.json();
  },

  upsert: async ({ name, permissions }) => {
    const response = await operatorApiFetch('permission_templates', {
      method: 'POST',
      body: JSON.stringify({
        permission_template: { name, permissions },
      }),
    });
    return response.json();
  },

  delete: async (id) => {
    const response = await operatorApiFetch(`permission_templates/${id}`, {
      method: 'DELETE',
    });
    return response.json();
  },
};

export default permissionTemplateService;
